import type { TPatientInfo } from "../../../../../services/api-clinic";
import type { ConsultPatient } from "../hooks/useConsultSearch";

const buildPatientName = (patient: TPatientInfo): string => {
  const name = `${patient.firstName || ""} ${patient.lastName || ""}`
    .trim()
    .replace(/\s+/g, " ");

  return name || patient.email || "Patient";
};

export const buildConsultPatientFromClinicPatient = (
  patient: TPatientInfo,
): ConsultPatient => ({
  id: patient.uuid,
  name: buildPatientName(patient),
  visitType: "Patient Record",
  email: patient.email || undefined,
  phone: patient.phone || undefined,
  procedureType: patient.proceduresOfInterest?.length
    ? patient.proceduresOfInterest.join(", ")
    : undefined,
  consultationDate:
    patient.updatedAt || patient.createdAt || new Date().toISOString(),
  patientRecordId: patient.uuid,
  clinicOSUUID: patient.uuid,
  hasPhotos: false,
});
